export default __webpack_public_path__ + "static/layout-dont-light-e154bbc06cfc71edf4bc3d301a5df5728f16975d049c788b11a513c2c685c9e7.png";